import { useEffect, useState } from 'react';
import { useEmployee } from './EmployeeContext';
import { useModal } from '../../components/ModalProvider';
import { useEnsureOnboarding } from './onboarding/useEnsureOnboarding';
import { employeeApi } from '../../lib/api';
import { applyTemplate } from '../../lib/format';
import { urlToDataUrl } from '../../lib/photo';
import { generateDocPDF } from '../../lib/pdf';
import { errorMessage } from '../../components/ErrorModalBody';

export function DocumentosTab() {
  const { employee, consent, signature } = useEmployee();
  const { showModal, closeModal } = useModal();
  const runGated = useEnsureOnboarding();
  const [docs, setDocs] = useState<any[]>([]);
  const [assinaturas, setAssinaturas] = useState<Record<string, any>>({});
  const [loading, setLoading] = useState(true);

  async function reload() {
    const res = await employeeApi.listDocumentos();
    setDocs(res.documentos);
    const entries = await Promise.all(res.documentos.map(async (d: any) => [d.id, (await employeeApi.getDocumentoAssinatura(d.id)).assinatura] as const));
    setAssinaturas(Object.fromEntries(entries));
  }
  useEffect(() => { setLoading(true); reload().finally(() => setLoading(false)); }, []);

  function openDoc(doc: any) {
    const assinatura = assinaturas[doc.id];
    const textoFinal = doc.texto ? applyTemplate(doc.texto, employee) : '';

    const Body = () => {
      const [nome, setNome] = useState('');
      const [agree, setAgree] = useState(false);
      const [err, setErr] = useState('');

      async function download() {
        const sigUrl = signature?.imagemUrl || null;
        const sigImg = sigUrl ? await urlToDataUrl(sigUrl) : null;
        generateDocPDF(doc, employee, assinatura, sigImg, applyTemplate);
      }

      function sign() {
        runGated(async () => {
          if (nome.trim().toLowerCase() !== employee.nome.trim().toLowerCase()) { setErr('O nome digitado precisa ser igual ao seu nome de cadastro: ' + employee.nome); return; }
          if (!agree) { setErr('Marque que você leu e concorda.'); return; }
          try {
            await employeeApi.signDocumento({ documentoId: doc.id, nomeDigitado: nome.trim() });
            closeModal();
            await reload();
          } catch (err) {
            setErr(errorMessage(err));
          }
        });
      }

      return (
        <>
          <h2>{doc.titulo} <span className="pill pill-tag">{doc.tipo || 'Outro'}</span></h2>
          {doc.link && <p style={{ margin: '8px 0' }}><a className="maplink" href={doc.link} target="_blank" rel="noreferrer">Abrir documento original ↗</a></p>}
          {doc.texto && <div className="doc-text">{textoFinal}</div>}
          {assinatura ? (
            <>
              <div className="banner" style={{ marginTop: 14 }}>Assinado por <b>{assinatura.nomeDigitado}</b> em {new Date(assinatura.assinadoEm).toLocaleString('pt-BR')}.</div>
              <button className="btn btn-primary btn-block" onClick={download}>Baixar PDF assinado</button>
              <button className="btn btn-ghost btn-block" style={{ marginTop: 8 }} onClick={closeModal}>Fechar</button>
            </>
          ) : (
            <>
              <hr className="div" />
              <label>Digite seu nome completo para assinar</label>
              <input type="text" placeholder={employee.nome} value={nome} onChange={(e) => setNome(e.target.value)} />
              <label className="checkrow"><input type="checkbox" checked={agree} onChange={(e) => setAgree(e.target.checked)} /> Li e concordo com o conteúdo acima</label>
              {err && <div className="err">{err}</div>}
              <div className="row" style={{ marginTop: 14 }}>
                <button className="btn btn-ghost" style={{ flex: 1 }} onClick={closeModal}>Cancelar</button>
                <button className="btn btn-primary" style={{ flex: 1 }} onClick={sign}>Assinar</button>
              </div>
            </>
          )}
        </>
      );
    };
    showModal(<Body />);
  }

  if (loading) return <div className="card"><p className="muted">Carregando…</p></div>;

  const termoCard = consent ? (
    <div className="card"><h2>Termo de aceite</h2><p className="hint">Aceito por você em {new Date(consent.aceitoEm).toLocaleString('pt-BR')}.</p></div>
  ) : null;

  if (docs.length === 0) {
    return <>{termoCard}<div className="card"><h2>Documentos</h2><p className="hint">Nenhum documento disponível no momento.</p></div></>;
  }

  return (
    <>
      {termoCard}
      <div className="card">
        <h2>Documentos</h2>
        {docs.map((d) => {
          const sig = assinaturas[d.id];
          return (
            <div className="doc-item" key={d.id}>
              <div>
                <div className="ttl">{d.titulo} <span className="pill pill-tag">{d.tipo || 'Outro'}</span></div>
                <div className="muted">{sig ? 'Assinado em ' + new Date(sig.assinadoEm).toLocaleString('pt-BR') : 'Pendente de assinatura'}</div>
              </div>
              <button className={`btn ${sig ? 'btn-ghost' : 'btn-primary'} btn-sm`} onClick={() => openDoc(d)}>{sig ? 'Ver' : 'Ler e assinar'}</button>
            </div>
          );
        })}
      </div>
    </>
  );
}
